module.exports = __webpack_public_path__ + "img/no_results.b6da60ad.svg";